<template>
  <button
    :id="id"
    @click.prevent="clicked()"
    :disabled="loading || disabled"
    class="btn d-flex align-items-center justify-content-center"
    :class="[{ 'w-100': fullWidth }, btnColor]"
  >
    <Spinner v-if="loading" size="sm" class="me-2" />

    <slot name="leftContent" v-if="$slots.leftContent" />

    <Typograph variant="action" class="mt-1">{{ label }}</Typograph>

    <slot name="rightContent" v-if="$slots.rightContent" />
  </button>
</template>

<script lang="ts" setup>
// TODO: Aplicar SOLID

import { computed } from "vue";

type ButtonProps = {
  disabled?: boolean;
  fullWidth?: boolean;
  loading?: boolean;
  outline?: boolean;
  label: string;
  color?: string;
  id?: string;
};

const {
  label,
  disabled = false,
  fullWidth = false,
  loading = false,
  outline = false,
  color = "primary",
} = defineProps<ButtonProps>();

const emits = defineEmits(["onClick"]);

const btnColor = computed(() =>
  outline ? `btn-outline-${color}` : `btn-${color}`
);

const clicked = () => {
  if (disabled) return;
  emits("onClick");
};
</script>
